module.exports = __webpack_public_path__ + "static/media/company-logo-3.3d8910e6.png";